/**
 * Wall Constants
 *
 * Shared constants for wall geometry processing.
 * Used by both cloud functions and shared-lib geometry modules.
 */

const DEFAULT_WALL_THICKNESS = 0.1143; // 4.5 inches in meters
const ZERO_THICKNESS_THRESHOLD = 0.001; // 1mm - walls thinner than this are considered zero-thickness

module.exports = { DEFAULT_WALL_THICKNESS, ZERO_THICKNESS_THRESHOLD };
